export const sevenConfig = {
    apiKey: window._env_?.REACT_APP_SEVEN_API_KEY || process.env.REACT_APP_SEVEN_API_KEY || '',
    endpoint: 'https://gateway.seven.io/api/sms',
    sender: window._env_?.REACT_APP_SEVEN_SENDER || process.env.REACT_APP_SEVEN_SENDER || 'HausbauSMS' // Max 11 alphanumeric characters
};
